import { PropsWithChildren } from "react";
import { AuthenticatedProps } from "../types";

export function MockAuthenticated({
  children,
}: PropsWithChildren<AuthenticatedProps>) {
  return <>{children}</>;
}
